// extracted by mini-css-extract-plugin
export default {"game_overlay":"Layout2_game_overlay__LDH8d","game_container":"Layout2_game_container__R4+On","game":"Layout2_game__HSjvj"};